import axios from 'axios';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { loginRequest } from '../../config/authConfig';

export const createAxiosInstance = (msalInstance) => {
    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        headers: {
            "Content-Type": "application/json",
        },
    });

    // Cache token promise to prevent multiple simultaneous token requests
    let tokenAcquisitionPromise = null;

    const getAccessToken = async () => {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0) {
            await msalInstance.loginRedirect();
            return null;
        }

        const tokenRequest = {
            ...loginRequest,
            account: accounts[0],
        };
        try {
            const response = await msalInstance.acquireTokenSilent(tokenRequest);
            return response.idToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                await msalInstance.acquireTokenRedirect(tokenRequest);
                return null;
            }
            throw error;
        }
    };

    axiosInstance.interceptors.request.use(
        async (config) => {
            try {
                if (!tokenAcquisitionPromise) {
                    tokenAcquisitionPromise = getAccessToken();
                }
                const token = await tokenAcquisitionPromise;
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            } catch (error) {
                console.error('Token acquisition failed:', error);
                return Promise.reject(error);
            } finally {
                tokenAcquisitionPromise = null;
            }
        },
    );

    // Add response interceptor to handle 401 errors
    axiosInstance.interceptors.response.use(
        response => response,
        async (error) => {
            if (error.response?.status === 401) {
                tokenAcquisitionPromise = null;
            }
            return Promise.reject(error);
        },
    );

    return axiosInstance;
};
